import Valkyrie, { viCircleInfo, viMagnifyingGlass, viSpinnerThird } from "@sippy-platform/valkyrie";

import { Grid, Typography } from "@mui/material";
import PropTypes from "prop-types";

function ContentLoader({ fetching, noResults, noItems, loading, count, icon = viCircleInfo }) {
  return (
    <Grid size={12} sx={{ textAlign: "center", pt: 16 }}>
      {count ? (
        <>
          <Typography variant="h1" color="primary">
            <Valkyrie icon={viMagnifyingGlass} />
          </Typography>
          <Typography variant="h5">{noResults}</Typography>
        </>
      ) : (
        <>
          {loading ? (
            <>
              <Typography variant="h1" color="primary">
                <Valkyrie icon={viSpinnerThird} spin />
              </Typography>
              <Typography variant="h5">{fetching}</Typography>
            </>
          ) : (
            <>
              <Typography variant="h1" color="primary">
                <Valkyrie icon={icon} />
              </Typography>
              <Typography variant="h5">{noItems}</Typography>
            </>
          )}
        </>
      )}
    </Grid>
  );
}

ContentLoader.propTypes = {
  fetching: PropTypes.string,
  noResults: PropTypes.string,
  noItems: PropTypes.string,
  loading: PropTypes.bool,
  count: PropTypes.number,
  icon: PropTypes.object,
};

export default ContentLoader;
